import { httpClient, urlPrefix, makeConfig } from '../data'
/**
 * Get groups
 * @param {*} postId
 * @param {*} typeId
 * @param {*} requestData
 */
export function list(postId, typeId, requestData) {
  return new Promise((resolve, reject) => {
    httpClient.http
      .get(
        `${urlPrefix}/contacts-types/${typeId}/custom-groups`,
        makeConfig(postId)
      )
      .then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(error)
        }
      )
  })
}



// WEBPACK FOOTER //
// ./src/apps/crm/contacts/api/groups/actions.js